import React, { useEffect, useState } from "react";
import { LOGIN } from "../config/apiConfig";
import { Alert, Button } from "flowbite-react";
import { useForm } from "react-hook-form";
import Input from "../components/inputs/Input";
import { Link } from "react-router-dom";
import axios from "axios";

const ForgotPassword = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorResponse, setErrorResponse] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    setErrorResponse("");
    setIsSuccess(false);

    try {
      await axios.get(`${LOGIN.FORGOT_PASSWORD}/${data.email}`);

      reset();
      setIsSuccess(true);
    } catch (err) {
      setErrorResponse(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section
      className="flex flex-col md:flex-row bg-primary-300 items-center justify-center px-3"
      style={{ height: "100vh" }}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="max-w-lg bg-white p-5 rounded-md shadow-md text-center"
      >
        <div className="underline font-semibold mb-2">Esqueceu sua senha?</div>
        <div className="text-gray-700 mb-3">
          Informe o e-mail cadastrado no sistema para redefinir sua senha.
          Enviaremos uma nova senha diretamente para seu e-mail.
        </div>
        <Input
          register={register}
          name="email"
          type="email"
          label="E-mail"
          required={true}
        />
        <Button
          className="w-full mt-2 primary"
          isProcessing={isSubmitting}
          disabled={isSubmitting}
          type="submit"
        >
          Enviar nova senha para o email
        </Button>
        <Link
          to="/"
          className="text-sm underline text-gray-500 mt-2 inline-block"
        >
          Voltar para a tela de login
        </Link>
        {isSuccess && (
          <Alert className="mt-2" withBorderAccent color="success">
            Nova senha enviada com sucesso para seu email!
          </Alert>
        )}

        {errorResponse && (
          <Alert className="mt-2" withBorderAccent color="failure">
            Ops! Algum erro inesperado ocorreu! Tentar novamente mais tarde.
          </Alert>
        )}
      </form>
    </section>
  );
};

export default ForgotPassword;
